module.exports = __webpack_public_path__ + "img/post-image2.16452eab.png";